function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    width: 32,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Microsoft"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue_x5F_Square"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    style: {
      fill: "#FFFFFF"
    },
    width: 15,
    y: 17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Yellow_x5F_Square"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    style: {
      fill: "#FFFFFF"
    },
    width: 15,
    x: 17,
    y: 17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Green_x5F_Square"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    style: {
      fill: "#FFFFFF"
    },
    width: 15,
    x: 17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Orange_x5F_Square"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    style: {
      fill: "#FFFFFF"
    },
    width: 15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoft-icon.8879e36ec0273f848b0630e8cd2a510f.svg";
export { ForwardRef as ReactComponent };